import React, { useEffect, useState } from 'react';
import CustomModal from '../../Modal/CustomModal';
import { Input } from 'reactstrap';
import './SearchInput.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Toast from '../../Toast/Toast';
import ReactTooltip from 'react-tooltip';
import Fetch from '../../../../../util/core/Fetch';

const SearchInput = ({ label, value, required, error, endpoint, onChange, onRemove, readOnly, searchParams, options, addButtonLabel }) => {

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [searchInitialRendering, setSearchInitialRendering] = useState('initial');

     useEffect(() => {
        setSelectedItems(value || []); 
    }, [value]);

    const handleInputClick = () => {
        setModalOpen(true);
        setSearchResults([]);
        setSearchInitialRendering('initial');
        setSearchTerm('');
    }

    const handleItemSelect = (item) => {
        if (selectedItems.some(selectedItem => selectedItem.id === item.id)) {
            Toast.warning('Este item já está na lista.');
        } else {
            setSelectedItems([...selectedItems, item]);
            onChange(item);
            setModalOpen(false);
            Toast.success('Item adicionado à lista.');
        }
    };

    const handleItemDeselect = (index) => {
        const updatedSelectedItems = [...selectedItems];
        const [item] = updatedSelectedItems.splice(index, 1);
        setSelectedItems(updatedSelectedItems);
        onRemove(item?.id);
    };

    useEffect(() => console.log({selectedItems}), [selectedItems]);

    const handleSearch = async () => {
        if (searchTerm !== '') {
            try {
                const body = { name: searchTerm, ...searchParams };
                const response = Fetch.post(endpoint, body);;
                const results = await response;
                setSearchResults(results);
                setSearchInitialRendering('');
            } catch (error) {
                Toast.error('Erro ao buscar. Tente novamente mais tarde.');
                setSearchInitialRendering('initial');
            }
        } else {
            setSearchResults([]);
            setSearchInitialRendering('initial');
        }
    };


    return (
        <div className="search-input-container">          
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                <label>
                    {label}
                    {required && (
                        <span className="required"> *</span>
                    )}
                </label>
                <button onClick={handleInputClick} type="button" className="btn btn-primary modal-button">{addButtonLabel || "Adicionar"}</button>
            </div>
            <CustomModal
                show={modalOpen}
                showButtons={false}
                size={'lg'}
                handleClose={() => setModalOpen(false)}
                title="Pesquisa"
                content={
                    <div>
                        <div className="search-bar">
                            <Input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Digite aqui para pesquisar..."
                            />
                            <button onClick={handleSearch} type="button" className="btn btn-secondary search-button">Pesquisar</button>
                        </div>
                        {searchInitialRendering === '' && !searchResults.length && (
                            <p>Nenhum resultado encontrado.</p>
                        )}
                        {searchInitialRendering !== 'initial' && searchResults.length > 0 && (
                             <div style={{maxHeight: '400px',
                                overflowY: 'auto'}}>
                            <table className="table-container">
                                <thead>
                                    <tr>
                                        {options.map((option, index) => (
                                            <th key={index}>{option.label}</th>
                                        ))}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {searchResults.map((result, rowIndex) => (
                                        <tr key={result.id}>
                                            <td>
                                                <td style={{ maxWidth: '50px' }}>
                                                    {result.photo ? (
                                                        <img src={result.photo} alt="Preview" style={{ width: '56px', height: '56px' }} />
                                                    ) : (
                                                        <FontAwesomeIcon icon={faUser} style={{ width: '56px', height: '56px' }} />
                                                    )}
                                                </td>
                                            </td>
                                            <td>{result.name}</td>
                                            <td>
                                                <div className="d-flex justify-content-center">
                                                    <a
                                                        className="btn btn-success btn-sm btn-action"
                                                        onClick={() => { handleItemSelect(result) }}
                                                        data-tip data-for={"tooltip-adicionar-" + result.id}
                                                        data-testid={`adicionar-${result.id}`}
                                                    >
                                                        <i className="fas fa-add">
                                                        </i>
                                                    </a>
                                                    <ReactTooltip id={"tooltip-adicionar-" + result.id} place="top" effect="solid">
                                                        Adicionar
                                                    </ReactTooltip>
                                                </div>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            </div>
                        )}
                    </div>
                }
            />
            {selectedItems.length > 0 &&
                <div>
                    <table className="table-container" style={{ marginTop: "1rem" }}>
                        <thead>
                            <tr>
                                {options.map((option, index) => (
                                    <th key={index}>{option.label}</th>
                                ))}
                                <th>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedItems.map((selectedItem, index) => (
                                <tr key={index}>
                                    <td style={{ maxWidth: '50px' }}>
                                        {selectedItem.photo ? (
                                            <img src={selectedItem.photo} alt="Preview" style={{ width: '56px', height: '56px' }} />
                                        ) : (
                                            <FontAwesomeIcon icon={faUser} style={{ width: '56px', height: '56px' }} />
                                        )}
                                    </td>
                                    <td>{selectedItem.name}</td>
                                    <td>
                                        {(!readOnly) && (
                                            <div className="d-flex justify-content-center">
                                                <a
                                                    className="btn btn-danger btn-sm btn-action"
                                                    onClick={() => { handleItemDeselect(index) }}
                                                    data-tip data-for={"tooltip-delete-" + index}
                                                    data-testid={`excluir-${index}`}
                                                >
                                                    <i className="fas fa-trash">
                                                    </i>
                                                </a>
                                                <ReactTooltip id={"tooltip-delete-" + index} place="top" effect="solid">
                                                    Excluir
                                                </ReactTooltip>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
            {error && (
                <span className="error invalid-feedback is-invalid">
                    {error}
                </span>
            )}
        </div>
    );
};

export default SearchInput;
